var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCf6(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.181,
    y1: 0.173,
    x2: 0.831,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff26af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff84eb"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_623",
    "data-name": "Group 623",
    transform: "translate(-860 -1184)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_132",
    "data-name": "Rectangle 132",
    transform: "translate(860 1184)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 47,
    height: 47,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_420",
    "data-name": "Group 420",
    transform: "translate(-4768.626 -3814.541)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_630",
    "data-name": "Path 630",
    d: "M184.768,150.638v30.511a1.1,1.1,0,0,1-1.1,1.1h-39.9a1.1,1.1,0,0,1-1.1-1.1V150.638a1.1,1.1,0,0,1,1.1-1.1h39.9A1.1,1.1,0,0,1,184.768,150.638Z",
    transform: "translate(5488.956 4857)",
    fill: "#5c6376"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_631",
    "data-name": "Path 631",
    d: "M439.068,150.638v30.511a1.1,1.1,0,0,1-1.1,1.1h-1.957V149.541h1.957A1.1,1.1,0,0,1,439.068,150.638Z",
    transform: "translate(5234.656 4857)",
    fill: "#4c5568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_632",
    "data-name": "Path 632",
    d: "M273.884,250.883l5.719-3.016a.868.868,0,0,0,0-1.536l-5.719-3.016a.868.868,0,0,0-1.273.768v6.031A.868.868,0,0,0,273.884,250.883Z",
    transform: "translate(5376.311 4775.794)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_419",
    "data-name": "Group 419",
    transform: "translate(5635.398 5010.09)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_633",
    "data-name": "Path 633",
    d: "M175.305,180.313h-3.2a1.1,1.1,0,0,1-1.1-1.1V177.3a1.1,1.1,0,0,1,1.1-1.1h3.2a1.1,1.1,0,0,1,1.1,1.1v1.913A1.1,1.1,0,0,1,175.305,180.313Z",
    transform: "translate(-171.009 -176.206)",
    fill: "#eaeef4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_634",
    "data-name": "Path 634",
    d: "M175.305,234.312h-3.2a1.1,1.1,0,0,1-1.1-1.1V231.3a1.1,1.1,0,0,1,1.1-1.1h3.2a1.1,1.1,0,0,1,1.1,1.1v1.913A1.1,1.1,0,0,1,175.305,234.312Z",
    transform: "translate(-171.009 -223.019)",
    fill: "#eaeef4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_635",
    "data-name": "Path 635",
    d: "M175.305,288.005h-3.2a1.1,1.1,0,0,1-1.1-1.1V285a1.1,1.1,0,0,1,1.1-1.1h3.2a1.1,1.1,0,0,1,1.1,1.1v1.913A1.1,1.1,0,0,1,175.305,288.005Z",
    transform: "translate(-171.009 -269.565)",
    fill: "#eaeef4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_636",
    "data-name": "Path 636",
    d: "M175.305,341.852h-3.2a1.1,1.1,0,0,1-1.1-1.1v-1.913a1.1,1.1,0,0,1,1.1-1.1h3.2a1.1,1.1,0,0,1,1.1,1.1v1.913A1.1,1.1,0,0,1,175.305,341.852Z",
    transform: "translate(-171.009 -316.245)",
    fill: "#eaeef4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_637",
    "data-name": "Path 637",
    d: "M394.391,180.313h-3.2a1.1,1.1,0,0,1-1.1-1.1V177.3a1.1,1.1,0,0,1,1.1-1.1h3.2a1.1,1.1,0,0,1,1.1,1.1v1.913A1.1,1.1,0,0,1,394.391,180.313Z",
    transform: "translate(-360.935 -176.206)",
    fill: "#eaeef4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_638",
    "data-name": "Path 638",
    d: "M394.391,234.16h-3.2a1.1,1.1,0,0,1-1.1-1.1V231.15a1.1,1.1,0,0,1,1.1-1.1h3.2a1.1,1.1,0,0,1,1.1,1.1v1.913A1.1,1.1,0,0,1,394.391,234.16Z",
    transform: "translate(-360.935 -222.886)",
    fill: "#eaeef4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_639",
    "data-name": "Path 639",
    d: "M394.391,288.005h-3.2a1.1,1.1,0,0,1-1.1-1.1V285a1.1,1.1,0,0,1,1.1-1.1h3.2a1.1,1.1,0,0,1,1.1,1.1v1.913A1.1,1.1,0,0,1,394.391,288.005Z",
    transform: "translate(-360.935 -269.565)",
    fill: "#eaeef4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_640",
    "data-name": "Path 640",
    d: "M394.391,341.852h-3.2a1.1,1.1,0,0,1-1.1-1.1v-1.913a1.1,1.1,0,0,1,1.1-1.1h3.2a1.1,1.1,0,0,1,1.1,1.1v1.913A1.1,1.1,0,0,1,394.391,341.852Z",
    transform: "translate(-360.935 -316.245)",
    fill: "#eaeef4"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCf6);
export default __webpack_public_path__ + "static/media/cf6.53301a9af62426204dbc2a72bd0c6f8d.svg";
export { ForwardRef as ReactComponent };